import { render, staticRenderFns } from "./GdprModal.vue?vue&type=template&id=c44b14f6&scoped=true"
import script from "./GdprModal.vue?vue&type=script&lang=js"
export * from "./GdprModal.vue?vue&type=script&lang=js"
import style0 from "./GdprModal.vue?vue&type=style&index=0&id=c44b14f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44b14f6",
  null
  
)

export default component.exports